/**
 * useSkerpaPageContext — Push visible page data to Skerpa context store.
 * Call from any page component to make Skerpa aware of what's on screen.
 * Context is automatically cleared when the view changes (via skerpaContextStore.setActiveView).
 */

import { useEffect } from 'react'
import { useSkerpaContextStore } from '@/stores/skerpaContextStore'

/**
 * Push a context string to Skerpa. Re-pushes whenever the data changes.
 * @param context - Plain text summary of what's visible. Pass empty string or null to clear.
 */
export function useSkerpaPageContext(context: string | null | undefined) {
  const setPageContext = useSkerpaContextStore(s => s.setPageContext)

  useEffect(() => {
    if (context) setPageContext(context)
  }, [context, setPageContext])
}
